<mat-toolbar class="subtitulo">Instituição</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <mat-horizontal-stepper #stepper style="background: transparent; padding: 10px">

        <!------------------ DADOS INICIAIS ------------------------>
        <mat-step [stepControl]="formCadastroDados">
            <form #formCadastroDados="ngForm">
                <ng-template matStepLabel>DADOS INICIAIS</ng-template>

                <dados-instituicao [instituicao]=instituicao></dados-instituicao>
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
                    <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>

        <!-- ------------------ FUNCOES ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formCadastroFuncoes">
            <form #formCadastroFuncoes="ngForm">
                <ng-template matStepLabel>FUNÇÕES</ng-template>
                <div ngModelGroup="funcoes">
                    <funcoes-instituicao [instituicao]=instituicao></funcoes-instituicao>
                </div>
            </form>
            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                  fxFlexFill>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

       
    </mat-horizontal-stepper>
</div>



<!-- BOTOES -->
<div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
    <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastroDados.invalid"
            (click)="cadastrar()"> Cadastrar
    </button>

    <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastroDados.invalid"
            (click)="atualizar()">
            Atualizar
    </button>

    <button *ngIf="mostrarBotaoLimpar()" 
            mat-raised-button 
            fxFlex="20%" 
            (click)="limpar()">
            Limpar
    </button>
    <button 
            mat-raised-button 
            fxFlex="20%" 
            (click)="cancelar()">
            Cancelar
    </button>

</div>
